import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderAlert = troubleshooting => {
  if (!troubleshooting) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginInline: "auto",
    marginBlockEnd: "200",
    maxInlineSize: "600px",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "troubleshoot.alertTitle"
    }),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "troubleshoot.alert"
    })
  });
};
const TroubleshootModeToggle = ({
  troubleshooting,
  toggleTroubleshootMode,
  fetchTroubleshootTimes
}) => {
  useEffect(() => {
    if (troubleshooting) {
      fetchTroubleshootTimes();
    }
  }, [fetchTroubleshootTimes, troubleshooting]);
  const troubleshootMessageKey = troubleshooting ? 'troubleshoot.exit_jsx' : 'troubleshoot.enter1_jsx';
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockStart: "400",
    textAlign: "center",
    backgroundColor: "fill-surface-recessed",
    children: [renderAlert(troubleshooting), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: troubleshootMessageKey,
      options: {
        onClick: () => toggleTroubleshootMode(!troubleshooting),
        use: 'link',
        'data-selenium-test': 'troubleshoot-button'
      },
      elements: {
        Button
      }
    }), !troubleshooting && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "troubleshoot.enter2"
      })
    })]
  });
};
TroubleshootModeToggle.propTypes = {
  troubleshooting: PropTypes.bool.isRequired,
  toggleTroubleshootMode: PropTypes.func.isRequired,
  fetchTroubleshootTimes: PropTypes.func.isRequired
};
export default TroubleshootModeToggle;